import { BRAND } from "@/config";

export const Scrn = ({ title, badge, children }) => (
    <div className="flex h-full flex-col bg-[#0b1422] px-3.5 pb-3.5 pt-6 text-left">
        <div className="flex items-center justify-between border-b border-white/5 pb-2">
            <div className="flex items-center gap-1.5">
                <img src={BRAND.icon} alt="" className="h-4.5 w-4.5 h-[18px] w-[18px]" />
                <span className="text-[10px] font-extrabold uppercase tracking-[0.14em] text-white">{title}</span>
            </div>
            {badge && (
                <span className="rounded-full bg-[#3fcbf3]/15 px-2 py-0.5 text-[7px] font-bold uppercase tracking-widest text-[#3fcbf3]">
                    {badge}
                </span>
            )}
        </div>
        <div className="mt-2.5 flex flex-1 flex-col gap-2 overflow-hidden">{children}</div>
    </div>
);

export const Box = ({ children, className = "" }) => (
    <div className={`rounded-lg border border-white/[0.07] bg-[#0f1a2e] p-2.5 ${className}`}>{children}</div>
);

export const Ln = ({ w = "w-2/3" }) => <div className={`h-1.5 ${w} rounded bg-white/10`} />;

export const Bar = ({ w = "50%", c = "#3fcbf3" }) => (
    <div className="h-1.5 w-full rounded-full bg-white/[0.07]">
        <div className="h-1.5 rounded-full" style={{ width: w, background: c }} />
    </div>
);

export const Ring = ({ pct = 0.75, label, sub, color = "#3fcbf3" }) => {
    const r = 26;
    const c = 2 * Math.PI * r;
    return (
        <div className="relative mx-auto h-[68px] w-[68px]">
            <svg viewBox="0 0 64 64" className="h-full w-full -rotate-90">
                <circle cx="32" cy="32" r={r} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth="6" />
                <circle
                    cx="32" cy="32" r={r} fill="none" stroke={color} strokeWidth="6"
                    strokeDasharray={`${c * pct} ${c}`} strokeLinecap="round"
                />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="text-[11px] font-extrabold text-white">{label}</span>
                {sub && <span className="text-[7px] uppercase tracking-widest text-[#7d8da3]">{sub}</span>}
            </div>
        </div>
    );
};

export const GradBtn = ({ children }) => (
    <div
        className="rounded-full py-2 text-center text-[9px] font-extrabold uppercase tracking-[0.15em] text-[#07101c]"
        style={{ background: "linear-gradient(92deg, #45d1f5 0%, #f0356f 100%)" }}
    >
        {children}
    </div>
);

export const ChipRow = ({ items, active = 0 }) => (
    <div className="flex flex-wrap gap-1.5">
        {items.map((t, i) => (
            <span
                key={`${t}-${i}`}
                className={`rounded-full border px-2 py-0.5 text-[8px] font-bold uppercase tracking-widest ${
                    i === active
                        ? "border-[#3fcbf3]/50 bg-[#3fcbf3]/10 text-[#3fcbf3]"
                        : "border-white/10 text-[#7d8da3]"
                }`}
            >
                {t}
            </span>
        ))}
    </div>
);

export const Tick = ({ done = true }) => (
    <span
        className={`flex h-3.5 w-3.5 items-center justify-center rounded-full text-[8px] font-black ${
            done ? "bg-[#3fcbf3]/20 text-[#3fcbf3]" : "border border-white/15 text-transparent"
        }`}
    >
        ✓
    </span>
);
